import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const shouldRedirectToRolloutsRoute = (workspace) => {
  if (EnvironmentService.enableLegacyProgressionsInStudio()) {
    return false;
  }
  if (!!(workspace == null ? void 0 : workspace.IsVNextExpMan)) {
    return true;
  }
  if (!!(workspace == null ? void 0 : workspace.IsUnifiedViewOptedIn)) {
    return true;
  }
  if (EnvironmentService.enableProgressionTemplates()) {
    return true;
  }
  return false;
};
export {
  shouldRedirectToRolloutsRoute
};
//# sourceMappingURL=FeatureRolloutOptIn.utils.js.map
